module.exports = __webpack_public_path__ + "img/jf_home_08.50199f89.jpg";